const services = [
  { icon: 'ri-scales-3-line', label: 'Liquidação de Sentença' },
  { icon: 'ri-refresh-line', label: 'Atualização de Cálculos' },
  { icon: 'ri-file-shield-2-line', label: 'Embargos à Execução' },
  { icon: 'ri-error-warning-line', label: 'Impugnações' },
  { icon: 'ri-arrow-up-circle-line', label: 'Agravos' },
  { icon: 'ri-receipt-line', label: 'Recibos de Expedição' },
  { icon: 'ri-shake-hands-line', label: 'Valores de Acordo' },
  { icon: 'ri-calculator-line', label: 'Qualquer Apuração Trabalhista' },
];

export default function Sobre() {
  return (
    <section id="sobre" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-500 mb-4">Sobre a Exato Cálculos</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
              Tecnologia e expertise jurídica em cada cálculo trabalhista
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              A Exato Cálculos atua em todas as demandas relacionadas a cálculos trabalhistas, combinando o conhecimento técnico de peritos experientes com uma <strong className="text-gray-700">IA exclusiva desenvolvida para análise jurídica trabalhista</strong>.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Nosso sistema garante maior assertividade, redução de erros, padronização técnica e ganho de escala — permitindo que advogados e escritórios foquem no que realmente importa: seus clientes.
            </p>

            <div className="flex flex-wrap gap-3">
              {[
                { icon: 'ri-brain-line', text: 'IA Exclusiva' },
                { icon: 'ri-shield-check-line', text: 'Segurança Jurídica' },
                { icon: 'ri-speed-line', text: 'Alta Agilidade' },
              ].map((tag) => (
                <span key={tag.text} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-sky-50 text-sky-700 text-sm font-medium">
                  <i className={`${tag.icon} text-base`}></i>
                  {tag.text}
                </span>
              ))}
            </div>
          </div>

          {/* Right - Services Grid */}
          <div>
            <div className="grid grid-cols-2 gap-4">
              {services.map((s) => (
                <div
                  key={s.label}
                  className="flex items-start gap-3 p-4 rounded-xl border border-gray-100 bg-gray-50 hover:border-sky-200 hover:bg-sky-50 transition-all duration-200 cursor-default"
                >
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-white border border-gray-200 shrink-0">
                    <i className={`${s.icon} text-sky-500 text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700 leading-snug mt-1">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
